import styled from 'styled-components';
var ContentContainer = styled.div.withConfig({
  displayName: "ProductCareContentstyles__ContentContainer",
  componentId: "sc-3icm3d-0"
})(["border-top:1px solid ", ";padding:0 15px;margin-bottom:25px;"], function (props) {
  return props.theme.color.monochrome.light;
});
var ContentTitle = styled.span.withConfig({
  displayName: "ProductCareContentstyles__ContentTitle",
  componentId: "sc-3icm3d-1"
})(["display:inline-block;margin:15px 0 0 0;margin-bottom:", ";font-size:20px;font-weight:", ";"], function (props) {
  return props.noMarginBottom ? '0px' : '20px';
}, function (props) {
  return props.theme.font.weight.bold;
});
var ContentListItem = styled.li.withConfig({
  displayName: "ProductCareContentstyles__ContentListItem",
  componentId: "sc-3icm3d-2"
})(["display:flex;align-items:center;flex-direction:row;margin:20px 0;"]);
var ContentListText = styled.span.withConfig({
  displayName: "ProductCareContentstyles__ContentListText",
  componentId: "sc-3icm3d-3"
})(["margin-left:10px;line-height:normal;"]);
var TickIconContainer = styled.div.withConfig({
  displayName: "ProductCareContentstyles__TickIconContainer",
  componentId: "sc-3icm3d-4"
})(["display:flex;align-items:center;justify-content:center;min-width:48px;height:48px;border-radius:24px;background-color:", ";"], function (props) {
  return props.theme.color.monochrome.lighter;
});
var CareProviderContainer = styled.div.withConfig({
  displayName: "ProductCareContentstyles__CareProviderContainer",
  componentId: "sc-3icm3d-5"
})(["display:flex;flex-direction:column;align-items:center;border-top:1px solid ", ";padding:20px;"], function (props) {
  return props.theme.color.monochrome.light;
});
var DGLogoContainer = styled.div.withConfig({
  displayName: "ProductCareContentstyles__DGLogoContainer",
  componentId: "sc-3icm3d-6"
})(["font-size:", ";line-height:normal;display:flex;justify-content:center;align-items:center;margin-bottom:20px;"], function (props) {
  return props.theme.font.size.caption;
});
var TrustPilotLogoContainer = styled.div.withConfig({
  displayName: "ProductCareContentstyles__TrustPilotLogoContainer",
  componentId: "sc-3icm3d-7"
})(["display:flex;flex-direction:column;justify-content:center;align-items:center;"]);
var ProviderText = styled.div.withConfig({
  displayName: "ProductCareContentstyles__ProviderText",
  componentId: "sc-3icm3d-8"
})(["font-size:", ";font-weight:", ";line-height:normal;vertical-align:middle;"], function (props) {
  return props.theme.font.size.caption;
}, function (props) {
  return props.theme.font.weight.bold;
});
var TrustPilotText = styled.p.withConfig({
  displayName: "ProductCareContentstyles__TrustPilotText",
  componentId: "sc-3icm3d-9"
})(["&&{font-size:", ";line-height:normal;margin:10px;text-align:center;}"], function (props) {
  return props.theme.font.size.caption;
});
var LegalTitle = styled.p.withConfig({
  displayName: "ProductCareContentstyles__LegalTitle",
  componentId: "sc-3icm3d-10"
})(["&&{font-size:", ";font-weight:", ";line-height:normal;margin-bottom:5px;border-top:1px solid ", ";}"], function (props) {
  return props.theme.font.size.caption;
}, function (props) {
  return props.theme.font.weight.bold;
}, function (props) {
  return props.theme.color.monochrome.light;
});
var LegalText = styled.p.withConfig({
  displayName: "ProductCareContentstyles__LegalText",
  componentId: "sc-3icm3d-11"
})(["&&{font-size:", ";line-height:normal;margin-bottom:10px;}"], function (props) {
  return props.theme.font.size.caption;
});
export { CareProviderContainer, ContentContainer, ContentTitle, ContentListItem, ContentListText, DGLogoContainer, TickIconContainer, TrustPilotLogoContainer, ProviderText, TrustPilotText, LegalTitle, LegalText };